/* STEP 3 · rule 2 — signs and amounts (owner 26-Oct-2026). B-2d: W9's absolute total, shown apart from the signed (net)
   "Amount" total that the heads add up to. EN + AR. Loaded from lib/i18n/ by the generated index (STEP 2 · B2). */
export const I18N_S3R2 = {
  en: {
    s3r2: {
      w9GrossAbs: "Gross (absolute)",
    },
  },
  ar: {
    s3r2: {
      w9GrossAbs: "الإجمالي (القيمة المطلقة)",
    },
  },
};

export default I18N_S3R2;
